import React, { useState } from 'react';
import InfoModal from './InfoModal';

// ✨ Стили для этого компонента теперь находятся в глобальном App.css, поэтому импорт удален.

const Sidebar = () => {
  const [infoOpen, setInfoOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [instructionOpen, setInstructionOpen] = useState(false);

  return (
    <aside className="wizard-sidebar">
      <div className="sidebar-widget sidebar-widget-clickable-elegant" onClick={() => setHelpOpen(true)}>
        <div className="widget-header">
          <h4 className="widget-title">
            <span className="widget-icon">💡</span> Как работать с договором?
          </h4>
        </div>
        <p className="widget-content">
          Подробная инструкция по заполнению договора, работе с полями и настройке условий.
        </p>
        <div className="widget-footer">
          <span className="widget-hint">Нажмите для подробностей</span>
        </div>
      </div>

      <div className="sidebar-widget sidebar-widget-clickable-elegant" onClick={() => setInstructionOpen(true)}>
        <div className="widget-header">
          <h4 className="widget-title">
            <span className="widget-icon">📋</span> Пошаговая инструкция
          </h4>
        </div>
        <p className="widget-content">
          Полная инструкция к заключению договора найма жилого помещения с описанием всех этапов и важных деталей.
        </p>
        <div className="widget-footer">
          <span className="widget-hint">Нажмите для подробностей</span>
        </div>
      </div>

      <div className="sidebar-widget sidebar-widget-clickable-elegant" onClick={() => setInfoOpen(true)}>
        <div className="widget-header">
          <h4 className="widget-title">
            <span className="widget-icon">📘</span> Почему договор найма? 
          </h4>
        </div>
        <p className="widget-content">
          Различия между договорами найма жилого помещения и аренды.
        </p>
        <div className="widget-footer">
          <span className="widget-hint">Нажмите для подробностей</span>
        </div>
      </div>


      <InfoModal isOpen={helpOpen} onClose={() => setHelpOpen(false)} title="Как работать с договором">
        <div className="info-content">
          <div className="info-section">
            <h4>Редактирование полей в тексте</h4>
            <p><strong>Кликайте на пунктирные поля</strong> прямо в тексте договора для быстрого редактирования. Поля автоматически подстраиваются под длину введённого текста.</p>
            <p>Некоторые поля являются обязательными — они подсвечиваются красным цветом, если остаются пустыми. Остальные поля можно оставить незаполненными.</p>
          </div>

          <div className="info-section">
            <h4>Выбор условий через кнопки</h4>
            <p>В разделах договора вы найдёте <strong>кнопки с готовыми формулировками</strong> для быстрого выбора условий:</p>
            <ul>
              <li><strong>Основные кнопки</strong> — выбор типа условий (например, "Безналичный расчёт" или "Наличный расчёт")</li>
              <li><strong>Дополнительные кнопки</strong> — уточнение деталей (например, "Расчёт за текущий месяц")</li>
              <li><strong>Опциональные кнопки</strong> — включение дополнительных пунктов (например, "Обеспечительный платеж предусмотрен")</li>
            </ul>
            <p>Нажатие на кнопку автоматически вставляет соответствующую формулировку в договор и обновляет связанные разделы.</p>
          </div>



          <div className="info-section">
            <h4>Сохранение и скачивание</h4>
            <p>Все изменения сохраняются автоматически. Для скачивания договора:</p>
            <ul>
              <li><strong>Требуется оплата</strong> — для скачивания нужно приобрести доступ к шаблону</li>
              <li><strong>Гостевой режим</strong> — можно заполнить договор без регистрации, данные автоматически сохранятся в личном кабинете после авторизации</li>
            </ul>
            <p>После оплаты вы сможете создавать и скачивать договоры по этому шаблону в течение указанного периода.</p>
          </div>

          <div className="info-section">
            <h4>Полезные советы</h4>
            <ul>
              <li>Персональные данные можно оставить пустыми и заполнить уже после скачивания договора или после распечатывания на бумаге</li>
              <li>Проверьте все данные перед скачиванием финального договора</li>
              <li>При сомнениях оставьте поле пустым — у Вас остается возможность изменить договор в течение 7 дней или заполните поля вручную после печати, а также есть возможность обратиться в техподдержку по электронной почте <a href="mailto:admin@dogovor-builder.ru">admin@dogovor-builder.ru</a></li>
              <li>Можете вернуться к любому разделу для редактирования в любой момент</li>
              <li>Изменения в одном разделе могут автоматически обновить связанные части договора</li>
              <li>Суммы автоматически записываются прописью и правильно склоняются</li>
            </ul>
          </div>
        </div>
      </InfoModal>

      <InfoModal isOpen={instructionOpen} onClose={() => setInstructionOpen(false)} title="Пошаговая инструкция к заключению договора найма">
        <div className="info-content">
          <div className="info-section">
            <h4>Пошаговая инструкция к заключению договора найма жилого помещения (квартиры)</h4>
            <p><strong>Наймодатель</strong> — собственник жилого помещения (квартиры) или управомоченное им лицо, действующие на основании доверенности.</p>
            <p><strong>Наниматель</strong> — физическое лицо (гражданин), получающее за плату права пользования и владения жилым помещением (квартирой).</p>
            <p>По договору найма жилого помещения собственник жилого помещения (Наймодатель) или управомоченное им лицо предоставляет (Нанимателю) жилое помещение (квартиру) за плату во владение и пользование для проживания в нем.</p>
          </div>

          <div className="info-section">
            <h4>1. Проверить документы на право собственности</h4>
            <p>Ознакомьтесь с документом на право собственности. Им может являться: договор купли-продажи, дарения, мены, свидетельство о праве на наследство, документы о приватизации жилого помещения, свидетельство о правах на недвижимое имущество, вступившие в силу решения суда (ч. 2 ст. 14 Закона от 13.07.2015 N 218-ФЗ).</p>
          </div>

          <div className="info-section">
            <h4>2. Проверить документы на регистрацию прав</h4>
            <p>Ознакомьтесь с выпиской из Единого государственного реестра недвижимости (ЕГРН). Проверьте следующие данные: кто является собственником помещения; на основании какого документа зарегистрировано право; есть ли обременения (залог, арест, аренда), препятствующие заключению договора найма. Также обратите внимание на дату выписки — она должна быть актуальной на момент подписания договора.</p>
          </div>

          <div className="info-section">
            <h4>3. Проверить задолженность по ЖКУ</h4>
            <p>Особенно важно, если Наниматель планирует оплачивать жилищно-коммунальные услуги самостоятельно. В этом случае стоит ознакомиться с последними квитанциями и проверить отсутствие задолженности в соответствующей графе. При подписании акта приема-передачи необходимо зафиксировать показания приборов учета и сверить их с данными в последней квитанции.</p>
          </div>

          <div className="info-section">
            <h4>4. Согласуйте условия договора</h4>
            <p><strong>Важно!</strong></p>
            <ul>
              <li><strong>5.1.</strong> В договоре необходимо указать точные данные, позволяющие идентифицировать помещение: адрес, площадь, кадастровый номер. При отсутствии каких-либо из этих данных договор может быть признан незаключенным.</li>
              <li><strong>5.2.</strong> Внесите реквизиты сторон, Ф.И.О, паспортные данные, адрес для корреспонденции, а также проследите, чтобы подписи сторон советовали подписям в паспорте.</li>
              <li><strong>5.3.</strong> Укажите размер платы за помещение, порядок и сроки ее внесения. Предусмотрите условия изменение размера платы, если это вам необходимо.</li>
              <li><strong>5.4.</strong> Пропишите, как будут распределяться между сторонами жилищно-коммунальные платежи. Согласно законодательству, Наниматель обязан самостоятельно оплачивать коммунальные платежи, если иное не указано в договоре.</li>
              <li><strong>5.5.</strong> Согласуйте срок найма, он не может составлять более пяти лет. Если срок не указан, договор считается заключенным на пять лет, а также можно прописать условия продления договора.</li>
              <li><strong>5.6.</strong> Не забудьте указать лиц, вселяющихся вместе с Вами. Если это несовершеннолетние дети, то указывать их отдельно не требуется.</li>
              <li><strong>5.7.</strong> Опишите условия пользования жилым помещением в договоре, такие как правила курения, содержания животных и иные условия.</li>
              <li><strong>5.8.</strong> Если помещение передается с имуществом, следует указать в договоре перечень и состояние такого имущества и определить ответственность за возможный ущерб.</li>
              <li><strong>5.9.</strong> Обсудите в договоре обеспечительный платеж (залоговую сумму), который вносится Нанимателем в целях обеспечения обязательств по договору (возмещение ущерба, уплата неустойки и т.п.), а также пропишите условия его возврата.</li>
              <li><strong>5.10.</strong> Рекомендуется описать в договоре условия посещения Наймодателем помещения для проверки его состояния.</li>
              <li><strong>5.11.</strong> Стоит предусмотреть условия текущего и капитального ремонта.</li>
              <li><strong>5.12.</strong> Также стоит указать ответственность сторон в случае ущерба, нарушения сроков оплаты или передачи помещения.</li>
            </ul>
          </div>

          <div className="info-section">
            <h4>5. Заключите договор найма и подпишите акт приема-передачи</h4>
            <p>Заключите договор найма жилого помещения с собственником или уполномоченным лицом, действующим на основании нотариальной доверенности, приложите копию доверенности к договору, а также проверьте его полномочия по сдаче помещения в наем.</p>
            <p>Подпишите акт приема-передачи помещения — это будет свидетельствовать о факте передачи прав владения и пользования. Опишите в нем состояние жилого помещения, оборудования, перечень имущества, показания приборов учета, выявленные недостатки. Рекомендуется сделать фотографии и/или видеозапись помещения, оборудования и имущества, а также их недостатков, с фиксацией даты и времени.</p>
          </div>

          <div className="info-section">
            <h4>6. Регистрация договора в Росреестр</h4>
            <p>При заключении договора найма помещения на срок не менее года данный договор подлежит государственной регистрации. Регистрация производится в течение месяца со дня заключения договора.</p>
            <p><strong>Внимание!</strong> Доход от сдачи помещения облагается НДФЛ.</p>
          </div>
        </div>
      </InfoModal>

      <InfoModal isOpen={infoOpen} onClose={() => setInfoOpen(false)} title="Почему договор найма?">
        <div className="info-content">
          <div className="info-section">
            <h4>Почему договор найма, а не аренды?</h4>
            <p><strong>Договор найма жилого помещения</strong> — это договор для передачи жилого помещения во временное владение и пользование, где сторонами выступают только физические лица. (Регулируется ГК РФ главой 35 «Наем жилого помещения»).</p>
            <p><strong>Договор аренды жилого помещения</strong> — это договор для передачи жилого помещения во временное владение и пользование, когда хотя бы одна сторона является юридическим лицом. (Регулируется ГК РФ главой 34 «Аренда»).</p>
          </div>

          <div className="info-section">
            <h4>⚠️ Почему это важно?</h4>
            <p>Если договор аренды жилого помещения будет заключен между физическими лицами, то при судебном разбирательстве суд переквалифицирует договор аренды в договор найма и будет рассматривать судебное дело, опираясь на главу 35 ГК РФ «Наем жилого помещения».</p>
          </div>

          <div className="info-section">
            <h4>Почему в интерфейсе «аренда»?</h4>
            <p>В быту так говорят 90% людей. Мы используем привычную терминологию, но генерируем юридически корректный договор найма жилого помещения.</p>
          </div>
        </div>
      </InfoModal>
    </aside>
  );
};

export default Sidebar;